export default "__VITE_ASSET__DVhyxyO6__"